import React from 'react'
import '../styles/navbar.css'
import {AiOutlineHome} from 'react-icons/ai'
import {FaUserTie} from 'react-icons/fa'
import {GiNotebook} from 'react-icons/gi'
import {MdApps} from 'react-icons/md'
import {MdOutlineContactPhone} from 'react-icons/md'
import { useState } from 'react';

const Navbar = () => {

  const [activeNav, setActiveNav] = useState('#');
  window.addEventListener('scroll' ,()=>{
    // console.log(window.scrollY);
    if(window.scrollY > 2980)
    setActiveNav('#contact');
    else if(window.scrollY > 1980)
    setActiveNav('#skills');
    else if(window.scrollY >  1260)
    setActiveNav('#experience');
    else if(window.scrollY > 588)
    setActiveNav('#about');
    else if(window.scrollY > 0)
    setActiveNav('#');
  })

  return (
    <nav className='navbar'>
      <a href="#" onClick={()=>setActiveNav('#')} className={activeNav ==='#' ? 'active' : ''}><AiOutlineHome/></a>
      <a href="#about" onClick={()=>setActiveNav('#about')} className={activeNav ==='#about' ? 'active' : ''}><FaUserTie/></a>
      <a href="#experience" onClick={()=>setActiveNav('#experience')} className={activeNav ==='#experience' ? 'active' : ''}><GiNotebook/></a>
      <a href="#portfolio" onClick={()=>setActiveNav('#skills')} className={activeNav ==='#skills' ? 'active' : ''}><MdApps/></a>
      <a href="#contact" onClick={()=>setActiveNav('#contact')} className={activeNav ==='#contact' ? 'active' : ''}><MdOutlineContactPhone/></a>
    </nav>
  )
}

export default Navbar;

